import type { AxiosClient } from './utils/client/axios';
import { ApiLayer } from './utils/api-layer';
import { axiosApp } from './utils/client/axios';

export type FeatureTypes = 'search-highlight' | 'scheduled_email_edit';

export type Toggle = {
  name: FeatureTypes;
  enabled: boolean;
};

class FeatureFlagsLayer extends ApiLayer<AxiosClient> {
  fetchFeatureFlags() {
    return this.methods.get<{ toggles: Toggle[] }>('/feature-flags');
  }
}

export const FeatureFlagsAPI = new FeatureFlagsLayer(axiosApp);
